import { FeeIdentifier } from "./identifier.fee";

export class PickupPointFee {
    public oid?:number;
    public name: string;
    public amountType:string;
    public amount:number;
    public paymentType:string;
    public identifier:FeeIdentifier;
    public category:string;
    public origin:string;
    public pickupPointOids: any[];

    constructor(obj?: PickupPointFee){
        if(!obj) {
            return {
                name: null,
                amountType:"PERCENTAGE",
                amount:0,
                paymentType:"UNIQUE",
                identifier: null,
                category:"FEE",
                origin:"FOREIGN",
                pickupPointOids: []
            };
        }else{
            return obj;
        }
    };
}


// WEBPACK FOOTER //
// ./public/upgrade/feature/pickuppointfee/edit/pickup-point.fee.ts